import type {
  FindUserReservationsFlightReservation,
  FindUserReservationsHotelReservation,
} from "@/types/codegen";

export enum ReservationType {
  PAST = "PAST",
  UPCOMING = "UPCOMING",
  REFUNDED = "REFUNDED",
}

export type ReservationStatus =
  | FindUserReservationsFlightReservation["status"]
  // we want to be explicit here
  // eslint-disable-next-line @typescript-eslint/no-duplicate-type-constituents
  | FindUserReservationsHotelReservation["status"];
